/* RR V1.5: lightweight accessible controls for the native-scrolling Brand Story carousel. */
(() => {
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  function initialize(section) {
    if (section.dataset.rrStoryCarouselInitialized === 'true') return;
    const gallery = section.querySelector('rr-campaign-gallery.rr-home-plp-grid');
    const controls = section.querySelector('.rr-campaign-story__controls');
    if (!gallery || !controls) return;
    section.dataset.rrStoryCarouselInitialized = 'true';
    const prev = controls.querySelector('[data-rr-story-prev]');
    const next = controls.querySelector('[data-rr-story-next]');
    const update = () => {
      const max = Math.max(0, gallery.scrollWidth - gallery.clientWidth);
      controls.hidden = max <= 2;
      prev.disabled = gallery.scrollLeft <= 2;
      next.disabled = gallery.scrollLeft >= max - 2;
    };
    const move = direction => {
      const item = gallery.querySelector('.rr-campaign-story__product');
      if (!item) return;
      const styles = getComputedStyle(gallery);
      const gap = Number.parseFloat(styles.columnGap) || 0;
      const step = item.getBoundingClientRect().width + gap;
      gallery.scrollBy({ left: direction * step, behavior: reducedMotion() ? 'auto' : 'smooth' });
    };
    const onPrev = () => move(-1);
    const onNext = () => move(1);
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    gallery.addEventListener('scroll', update, { passive: true });
    let observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(gallery);
      const first = gallery.querySelector('.rr-campaign-story__product');
      if (first) observer.observe(first);
    } else window.addEventListener('resize', update);
    section.rrStoryDispose = () => {
      observer?.disconnect();
      if (!observer) window.removeEventListener('resize', update);
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
      gallery.removeEventListener('scroll', update);
      section.dataset.rrStoryCarouselInitialized = 'false';
    };
    update();
  }
  function scan(root = document) {
    if (root.matches?.('.rr-campaign-story--products')) initialize(root);
    root.querySelectorAll?.('.rr-campaign-story--products').forEach(initialize);
  }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('.rr-campaign-story--products')) event.target.rrStoryDispose?.();
    event.target.querySelectorAll?.('.rr-campaign-story--products').forEach(s => s.rrStoryDispose?.());
  });
})();
